import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";

import { set } from "lodash";

function EssentialTables({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  errors,
  setErrors,
  setFormValues,
  setRowIndex,
  disabled,
}) {
  const [columnArray, setColumnArray] = useState([]);
  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (item.value && !["grievanceRedressalMechanism"].includes(item.key)) {
        heading.slice(1).forEach((headings) => {
          const name = `${item.key}.${headings.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const calculatePercentages = (currentValues, fieldKey, updatedValue) => {
    const male =
      fieldKey === "male" ? updatedValue : Number(currentValues.male || 0);
    const female =
      fieldKey === "female" ? updatedValue : Number(currentValues.female || 0);
    const total =
      fieldKey === "total" ? updatedValue : Number(currentValues.total || 0);

    return {
      male,
      female,
      total,
      malepercentage: (male / total) * 100 || 0,
      femalepercentage: (female / total) * 100 || 0,
    };
  };

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value;
          // Update the specific field
          if (
            key === "code" &&
            value === "No" &&
            typeof current === "object" &&
            "remark" in current
          ) {
            current["remark"] = "";
          } else {
            current[key] = { ...current[key] };
            current = current[key];
          }
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Split the `name` into parts based on uppercase letters
    const nameParts = name.split("."); // Splits on uppercase letters
    const mainKey = nameParts[0];

    const subKey = nameParts[1];

    const fieldKey = nameParts[2];

    // const turnoverRate = item.key?.includes("turnoverrate");

    setFormValues((prev) => {
      const currentValues = prev[mainKey]?.[subKey];

      const updatedValue = Number(value);

      // Use helper function for calculations
      return {
        ...prev, // Spread the previous state to keep other keys intact
        [mainKey]: {
          ...prev[mainKey], // Keep other fields within `mainKey` intact
          [subKey]: {
            ...currentValues,
            [fieldKey]: value, // Update the specific field
          },
        },
      };
    });
  };

  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "Capitalize",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{ marginBottom: "20px", fontWeight: "bold", marginTop: "10px" }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%", borderRadius: "10px", overflow: "hidden" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item) => {
            if (item.value) {
              // const isTotalRow = item.value.includes("Total"); // Check if the row is a Total row

              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,

                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                    gridRow: item.type === "rowSpan" ? "span 2" : "auto",

                    // gridRow: item.type === "rowSpan" ? "span 2" : "auto",
                  }}
                >
                  <Box
                    sx={{
                      gridRow: item.type === "rowSpan" ? "span 3" : "auto", // Apply rowSpan for item
                      borderRight: "1px solid #DBDBDB",
                    }}
                  >
                    {/* Render Typography for the row */}
                    <Typography
                      sx={{
                        borderRight: "1px solid #DBDBDB",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const name = `${item.key}.${headings.key}`;

                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");

                      // Ensure the split result is valid
                      if (matchResult.length < 3) {
                        console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [mainKey, subKey, fieldKey, differentlyAbledKey] =
                        matchResult;

                      // const isPercentage = headings.title.includes("%");
                      const isPercentage =
                        headings.key !== "employeesCovered" &&
                        headings.key !== "workersCovered" &&
                        headings.title.includes("%");
                      const isTotal = headings.title.includes("Total");

                      return (
                        <>
                          {headings.type === "boolean" ? (
                            <FormControl
                              fullWidth
                              size="small"
                              disabled={disabled}
                              sx={{
                                padding: "0px 5px",
                                borderRight: "1px solid #DBDBDB",
                              }}
                            >
                              <Select
                                id={name}
                                name={name}
                                value={
                                  (mainKey === "grievanceRedressalMechanism" &&
                                    formValues?.[mainKey]?.[subKey]?.code) ||
                                  "No"
                                }
                                onChange={(e) =>
                                  handleChangeRadio({
                                    target: {
                                      name,
                                      value: e.target.value,
                                    },
                                  })
                                }
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                  backgroundColor: disabled
                                    ? "#f5f5f5"
                                    : "transparent", // optional for visual clarity
                                  height: 40,
                                }}
                              >
                                {["Yes", "No"].map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : item?.subvalue?.length > 0 &&
                            headings.title === "Category" ? (
                            item?.subvalue?.length > 0 &&
                            headings.title === "Category" &&
                            item?.subvalue.map((item) => {
                              return <Typography>{item.value}</Typography>;
                            })
                          ) : (
                            <TextField
                              key={index} // Adding a key for mapping
                              variant="standard"
                              sx={{
                                background:
                                  formValues?.[mainKey]?.[subKey]?.code ===
                                  "Yes"
                                    ? ""
                                    : "#EFEFEF",
                                // backgroundColor: isPercentage || isTotal ||isTotalRow ? "#EFEFEF" : "",
                                borderRight: "1px solid #DBDBDB",
                                padding: "8px 12px",
                                "& .MuiInputBase-root": {
                                  padding: 0, // Align with grid cells
                                },
                              }}
                              name={name}
                              type="text"
                              InputProps={{
                                disableUnderline: true,
                                readOnly:
                                  formValues?.[mainKey]?.[subKey]?.code ===
                                  "Yes"
                                    ? false
                                    : true,
                              }}
                              fullWidth
                              size="small"
                              disabled={
                                (formValues?.[mainKey]?.[subKey]?.code === "Yes"
                                  ? false
                                  : true) || disabled
                              }
                              value={
                                formValues?.[mainKey]?.[subKey]?.[fieldKey] ||
                                ""
                              }
                              placeholder={
                                isTotal
                                  ? "Total"
                                  : isPercentage
                                  ? "%"
                                  : "Type Here"
                              }
                              onChange={(e) => handleChange(e, index)}
                              // onChange={!isTotalRow ? (e) => handleChange(e, index) : undefined}
                            />
                          )}
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>
      {Array.isArray(errors) && errors.length > 0
        ? Object.entries(
            errors?.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(item.fieldName);
              return acc;
            }, {})
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
              {/* Row {rowIndex}: {fields.join(", ")} */}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default EssentialTables;
